var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{attrs:{"shadow":"never"}},[_c('p',{attrs:{"align":"justify"}},[_vm._v("\n\t\t\tNo se encontró la página\n\t\t")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }